/**
 * capitalize
 * @description capitalizes the firsct character of the string
 * @returns {String}
 */
export const capitalize = (value = "") => {
  if (!value) return;
  return `${value.slice(0, 1).toUpperCase()}${value.slice(1, value.length)}`;
};
